import controller from './facility-reporting-grid-controller';
import template from './facility-reporting-grid.html'

const FacilityReportingGridComponent = {
    bindings: {
        reportList: '<',
        year: '<'
    },
    controller,
    template,
};

export default FacilityReportingGridComponent;



// WEBPACK FOOTER //
// ./app/components/facility-reporting/facility-reporting-grid/facility-reporting-grid-component.js